import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Pro demo: jednoduché ověření, v produkci použij API
    if (username === 'skalice' && password === 'Hnatek1927') {
      localStorage.setItem('isAdmin', 'true');
      onLogin();
    } else {
      setError('Neplatné přihlašovací údaje');
    }
  };

  return (
        <div className="container d-flex justify-content-center mt-5">
      <div className="card shadow-sm w-100" style={{maxWidth: 380}}>
        <div className="card-body">
          <h2 className="card-title text-center mb-4">Přihlášení do administrace</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Uživatelské jméno</label>
              <input
                type="text"
                className="form-control"
                placeholder="Uživatelské jméno"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoFocus
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Heslo</label>
              <input
                type="password"
                className="form-control"
                placeholder="Heslo"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            {error && <div className="alert alert-danger py-2 mb-3">{error}</div>}
            <button type="submit" className="btn btn-primary w-100">Přihlásit se</button>
          </form>
        </div>
      </div>
    </div>
  );
}
